import { Alert, Snackbar } from "@mui/material";
import { createContext, useContext, useState } from "react";

const NotifyContext = createContext()
export function Notify(props) {
    const [notify, setNotify] = useState({
        open: false
    })

    function closeNotify() {
        setNotify({
            ...notify,
            open: false
        })
    }

    return <NotifyContext.Provider
        value={{
            notify, setNotify, closeNotify
        }}
        {...props}>
        {props.children}
        <NotifyMessage />
    </NotifyContext.Provider>
}

function NotifyMessage(props) {
    const { notify, closeNotify } = useContext(NotifyContext);

    return <Snackbar

        open={notify.open}
        onClose={closeNotify}
        autoHideDuration={8000}
    >
        <Alert onClose={closeNotify} severity={notify.type || 'info'}>
            {notify.message}
        </Alert>
    </Snackbar>
}

export function useNotify() {
    const { setNotify } = useContext(NotifyContext);

    function message(msg, type) {
        setNotify({
            open: true,
            message: msg,
            type,
        })
    }

    return {
        message
    }
}